/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function RoleCreator({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M6 6.9a.6.6 0 0 0 0 1.2h1.4v2.4a.6.6 0 1 0 1.2 0V8.1H10a.6.6 0 1 0 0-1.2z" /><path fill="currentColor" fillRule="evenodd" d="M8 .4a5.6 5.6 0 0 0-2.6 10.561V12A1.6 1.6 0 0 0 7 13.6h2a1.6 1.6 0 0 0 1.6-1.6v-1.039A5.6 5.6 0 0 0 8 .4M3.6 6a4.4 4.4 0 1 1 6.16 4.034.6.6 0 0 0-.36.55V12a.4.4 0 0 1-.4.4H7a.4.4 0 0 1-.4-.4v-1.416a.6.6 0 0 0-.36-.55A4.4 4.4 0 0 1 3.6 6" clipRule="evenodd" /><path fill="currentColor" d="M6 14.4a.6.6 0 0 0 0 1.2h4a.6.6 0 1 0 0-1.2z" /></svg>;
}
;